import {
    Create,
    FormDataConsumer,
    required,
    SelectInput,
    SimpleForm,
    TextInput,
    useNotify,
} from 'react-admin';
import * as React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { goApi } from '../../services';
import { apiRoutes } from '../../services/apiRoutes';
import { validateNotEmpty } from '../../common/VideoPlayer/util';
import FileUpload from '../../common/inputs/FileUpload';

const BulkUploadCreate = ({ selectedType }: { selectedType?: string }) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const notify = useNotify();

    const [types, setTypes] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const fetchTypes = async () => {
            try {
                setLoading(true);
                const response = await goApi.get<any>(apiRoutes.BULK_UPLOAD_TYPES);
                const items = response?.data?.items || response?.data || [];
                setTypes(items);
            } catch (error) {
                notify('Failed to load bulk upload types', { type: 'error' });
            } finally {
                setLoading(false);
            }
        };

        fetchTypes();
    }, [notify]);
    const DEFAULT_TYPE = selectedType;
    return (
        <Create redirect="list" resource="bulk-uploads">
            <SimpleForm
                defaultValues={{
                    typeId: user?.organization_id,
                }}
            >
                <TextInput source="name" fullWidth validate={[required(), validateNotEmpty]} />
                <SelectInput
                    source="type"
                    label="Type"
                    fullWidth
                    validate={[required()]}
                    choices={types}
                    defaultValue={DEFAULT_TYPE}
                    readOnly={DEFAULT_TYPE ? true : false}
                    optionText="name"
                    optionValue="type"
                    disabled={loading}
                />
                <FormDataConsumer>
                    {({ formData }) => {
                        const selectedType = types.find(type => type.type === formData?.type);

                        return (
                            <>
                                {selectedType?.link && (
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                                            Download sample file:
                                        </Typography>
                                        <Link
                                            href={selectedType.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                        >
                                            {selectedType.name} Sample File
                                        </Link>
                                    </Box>
                                )}
                                <FileUpload
                                    source="fileUrl"
                                    type="BULK_UPLOAD"
                                    typeId={formData?.typeId}
                                    accept=".csv,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                                    label="Upload CSV or Excel File"
                                    required
                                />
                                {formData?.type === 'TEST_QUESTION_UPLOAD' && (
                                    <FileUpload
                                        source="config.imageUrl"
                                        type="BULK_UPLOAD_IMAGE"
                                        typeId={formData?.typeId}
                                        accept="image/*,.zip,application/zip,application/x-zip-compressed"
                                        label="Upload Image or Zip File"
                                    />
                                )}
                            </>
                        );
                    }}
                </FormDataConsumer>
            </SimpleForm>
        </Create>
    );
};

export default BulkUploadCreate;
